var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomainsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E7F2F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1697_5167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1697_5167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6668C15.0778 22.6668 14.2112 22.4918 13.4 22.1418C12.5889 21.7918 11.8834 21.3168 11.2834 20.7168C10.6834 20.1168 10.2084 19.4113 9.85837 18.6002C9.50837 17.7891 9.33337 16.9224 9.33337 16.0002C9.33337 15.0779 9.50837 14.2113 9.85837 13.4002C10.2084 12.5891 10.6834 11.8835 11.2834 11.2835C11.8834 10.6835 12.5889 10.2085 13.4 9.8585C14.2112 9.5085 15.0778 9.3335 16 9.3335C16.9223 9.3335 17.7889 9.5085 18.6 9.8585C19.4112 10.2085 20.1167 10.6835 20.7167 11.2835C21.3167 11.8835 21.7917 12.5891 22.1417 13.4002C22.4917 14.2113 22.6667 15.0779 22.6667 16.0002V16.9668C22.6667 17.6224 22.4417 18.1807 21.9917 18.6418C21.5417 19.1029 20.9889 19.3335 20.3334 19.3335C19.9445 19.3335 19.5778 19.2502 19.2334 19.0835C18.8889 18.9168 18.6 18.6779 18.3667 18.3668C18.0445 18.6891 17.6806 18.9307 17.275 19.0918C16.8695 19.2529 16.4445 19.3335 16 19.3335C15.0778 19.3335 14.2917 19.0085 13.6417 18.3585C12.9917 17.7085 12.6667 16.9224 12.6667 16.0002C12.6667 15.0779 12.9917 14.2918 13.6417 13.6418C14.2917 12.9918 15.0778 12.6668 16 12.6668C16.9223 12.6668 17.7084 12.9918 18.3584 13.6418C19.0084 14.2918 19.3334 15.0779 19.3334 16.0002V16.9668C19.3334 17.2557 19.4278 17.5002 19.6167 17.7002C19.8056 17.9002 20.0445 18.0002 20.3334 18.0002C20.6223 18.0002 20.8612 17.9002 21.05 17.7002C21.2389 17.5002 21.3334 17.2557 21.3334 16.9668V16.0002C21.3334 14.5113 20.8167 13.2502 19.7834 12.2168C18.75 11.1835 17.4889 10.6668 16 10.6668C14.5112 10.6668 13.25 11.1835 12.2167 12.2168C11.1834 13.2502 10.6667 14.5113 10.6667 16.0002C10.6667 17.4891 11.1834 18.7502 12.2167 19.7835C13.25 20.8168 14.5112 21.3335 16 21.3335H19.3334V22.6668H16ZM16 18.0002C16.5556 18.0002 17.0278 17.8057 17.4167 17.4168C17.8056 17.0279 18 16.5557 18 16.0002C18 15.4446 17.8056 14.9724 17.4167 14.5835C17.0278 14.1946 16.5556 14.0002 16 14.0002C15.4445 14.0002 14.9723 14.1946 14.5834 14.5835C14.1945 14.9724 14 15.4446 14 16.0002C14 16.5557 14.1945 17.0279 14.5834 17.4168C14.9723 17.8057 15.4445 18.0002 16 18.0002Z",
    fill: "#0D8091"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainsIcon);
export default __webpack_public_path__ + "static/media/DomainsIcon.b7626272889c5e4d3f3131628e6dd6ce.svg";
export { ForwardRef as ReactComponent };